// src/pages/UserChat.jsx
import {ChatWindow} from '../../components';

const UserChat = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <ChatWindow />
    </div>
  );
};

export default UserChat;
